import React from "react";
import PageHero from "@/components/PageHero";
import Section from "@/components/Section";
import useSeo from "@/hooks/useSeo";

export default function Privacy() {
  useSeo("privacy", {
    title: "Privacy Policy — Quantum Results",
    description:
      "How Quantum Results collects, uses, and protects your information.",
  });
  return (
    <div data-testid="page-privacy">
      <PageHero
        eyebrow="Legal"
        title="Privacy Policy"
        lede="Quantum Results LLC respects your privacy. This policy explains what we collect, why we collect it, and the choices you have."
        testId="privacy-hero"
      />
      <Section testId="privacy-body">
        <p><strong>Effective date:</strong> {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">What we collect</h3>
        <p>When you contact us or join a waitlist, we collect the information you choose to provide — typically your name, email, and message. When you schedule a conversation via Calendly, Calendly collects the information required to create the meeting.</p>
        <p>We use privacy-conscious analytics (Google Analytics 4) to understand how visitors use the site in aggregate. We do not sell or share personal data with advertisers.</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">How we use it</h3>
        <p>We use your information to respond to you, deliver the experience you requested, and — with your permission — occasionally keep you informed about relevant developments. That's it.</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">Retention & your choices</h3>
        <p>Contact submissions are retained for up to 90 days by default, then removed on request. You may ask us to delete or export your information at any time by writing to <a className="link-quiet" href="mailto:info@quantumresults.com">info@quantumresults.com</a>.</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">Security</h3>
        <p>Data is encrypted in transit (TLS 1.2+) and at rest (AES-256). Access is restricted to authorized personnel using least-privilege credentials.</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">Contact</h3>
        <p>Questions about this policy? Please write to <a className="link-quiet" href="mailto:info@quantumresults.com">info@quantumresults.com</a>.</p>
      </Section>
    </div>
  );
}
